import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=fb23794a&"
import script from "./Icon.vue?vue&type=script&lang=ts&"
export * from "./Icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports